import { apiService } from './apiService';

export interface DriverActivity {
  id: number;
  shipment_id: number | null;
  driver_id: number | null;
  driver_name: string | null;
  vehicle_plate: string | null;
  action_type: string;
  action_label: string | null;
  stage_key: string | null;
  description: string | null;
  metadata: any;
  created_at: string;
}

export const driverActivityService = {
  async log(params: {
    shipment_id?: number;
    driver_id?: number;
    driver_name?: string;
    vehicle_plate?: string;
    action_type: string;
    action_label?: string;
    stage_key?: string;
    description?: string;
    metadata?: any;
  }): Promise<DriverActivity> {
    const data: any = await apiService.post('/driver-activities/log', params);
    if (!data.success) throw new Error(data.message);
    return data.data;
  },

  async getAll(params?: { shipment_id?: number; driver_id?: number; action_type?: string; limit?: number }): Promise<DriverActivity[]> {
    const query = new URLSearchParams();
    if (params?.shipment_id) query.set('shipment_id', String(params.shipment_id));
    if (params?.driver_id) query.set('driver_id', String(params.driver_id));
    if (params?.action_type) query.set('action_type', params.action_type);
    if (params?.limit) query.set('limit', String(params.limit));
    const data: any = await apiService.get(`/driver-activities${query.toString() ? `?${query.toString()}` : ''}`);
    if (!data.success) throw new Error(data.message);
    return data.data;
  },

  async getByShipment(shipmentId: number): Promise<DriverActivity[]> {
    const data: any = await apiService.get(`/driver-activities/shipment/${shipmentId}`);
    if (!data.success) throw new Error(data.message);
    return data.data;
  },
};
